export const missingCardMessage = 'Missing billing address on payment card';

export const achievements = {
  rung2: {
    title: 'Full-Price Achievement',
    description: 'Purchased at least two full-priced items in last 36 months',
  },
  rung3: {
    title: 'Wardrobe Achievement',
    description: 'Shopped in 5+ divisions in the last 36 months',
  },
  rung4: {
    title: 'Upsell Achievement',
    description: 'Made at least two single-item purchases of $1,000 or more in last 36 months',
  },
  rung5: {
    title: 'Relationship Achievement',
    description: 'Client has at least one dedicated associate',
  },
  rung6: {
    title: 'Big Ticket Achievement',
    description: 'Made a single-item purchase of $50,000 or more in last 36 months',
  },
};

export const BADGES_FILTER_OPTIONS = [
  {
    label: 'Full-Price Achievement',
    value: 'rung2',
  },
  {
    label: 'Wardrobe Achievement',
    value: 'rung3',
  },
  {
    label: 'Upsell Achievement',
    value: 'rung4',
  },
  {
    label: 'Relationship Achievement',
    value: 'rung5',
  },
  {
    label: 'Big Ticket Achievement',
    value: 'rung6',
  },
];

export const ASSETS_FILTER_OPTIONS = [
  {
    label: 'Promo Card',
    value: 'PROMO',
  },
  {
    label: 'Point Card',
    value: 'POINT',
  },
];
export const PLCCHolderRoles = {
  authorizedUser: 'AU',
  coHolder: 'CH',
  primary: 'PR',
};
